import React, { useEffect } from "react";
import { Col, Divider, Drawer, Dropdown, Form, Input, Menu, Modal, Pagination, Row, Table } from "antd";
import {
  Descriptions,
  Breadcrumb,
  PageHeader,
  Tag,
  Empty,
  Timeline,
  Button,
} from "antd";
import { useState } from "react";
import { connect } from "react-redux";
import {
  getAppUsersDetails,changeAppUserAuth
} from "../../actions/appUser";

import { Title, Wrapper } from "./detailStyle";
import { Content, Header } from "antd/lib/layout/layout";
import { Link } from "react-router-dom";
import Remarks from "../../component/remark";
import {
  CheckSquareFilled,
  EditOutlined,
  KeyOutlined,
  SettingOutlined,
  WarningOutlined,
} from "@ant-design/icons";

import { renderInput, renderSelect, renderTextField } from "../../component/form/form";
const tailLayout = {
  wrapperCol: { offset: 4, span: 16 },
};
const comapny = [
  {value: 'individual', label: 'Person'},
  {value: 'company', label: 'Company'},
  
]
const menu = ( showDrawer) => (
  <Menu >
    
    <Menu.Item onClick={() => showDrawer()}>Password Setting</Menu.Item>
    
  </Menu>
);


const AppUserDetails = ({
  location,
  getAppUsersDetails,
  changeAppUserAuth
}) => {
  const [data, setData] = useState([]);
  const [data1, setData1] = useState([]);

  const [remark, setRemark] = useState(false);
  const [remarkaccount, setRemarkAccount] = useState(false);
  const [visibleP, setVisibleP] = useState(false);
  const [auth, setAuth] = useState(false);
  const [active, setActive] = useState(false);
  const [visibleUC, setVisibleUC] = useState(false);
  const [form] = Form.useForm();
  const [visibleC, setVisibleC] = useState(false);
  const [visible, setVisible] = useState(false);

 

  const id = new URLSearchParams(location.search).get("id");

  async function fetchData() {
    const res = await getAppUsersDetails(id);
    setData(res)
  }


  
  const handleRefresh = async () => {
    const res = await getAppUsersDetails(data?.user_id);
    setData(res);
  };
  const handleOk = () => {
    setVisibleC(false);
  };

  const onClose = () => {
    setVisibleP(false);
    };

  const handleCancel = () => {
    setVisibleC(false);
  };

  useEffect(() => {
    fetchData();
  }, []);

  const onFinish = async (values) => {
    const code = await changeAppUserAuth(values, data.user_id);
    if (code === 201) {
      handleRefresh();
      setVisible(false);
    }
  };
  const onFinishFailed = (errorInfo) => {
  };



  const makeLocalTime = (date) => {
    let hours = date?.split("T")[1].split(":")[0];
    let minutes = date?.split("T")[1].split(":")[1];
    var am = true;
    if (hours > 12) {
      am = false;
      hours -= 12;
    } else if (hours === 12) {
      am = false;
    } else if (hours === 0) {
      hours = 12;
    }
    return (
      date?.split("T")[0] +
      "," +
      hours +
      ":" +
      minutes +
      " " +
      (am ? "A.M" : "P.M")
    );
  };

  return (
    <Content>
      <Breadcrumb style={{ padding: "10px 0px" }}>
        <Breadcrumb.Item>
          <Link to="/dashboard">Home</Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item>User Details</Breadcrumb.Item>
      </Breadcrumb>

   
      <PageHeader
        ghost={false}
        onBack={() => window.history.back()}
        title="User Details"
        subTitle="App Management"
      ></PageHeader>
      
      <Wrapper>
        <h2>
          Client Name : {data?.first_name} {data?.last_name}
        </h2>
        
             

        {data?.authenticated ? (
          <Tag color="#6fcf20">Authenticate</Tag>
        ) : (
          <Tag color="#e96710">Unauthenticate</Tag>
        )}
        <Tag color="#c237a4" >{data?.created_at ? makeLocalTime(data?.created_at): null}</Tag>


        {!data?.authenticated ? (
          <Button
            type="ghost"
            icon={<CheckSquareFilled />}
            size="small"
            style={{
              float: "right",
              backgroundColor: "#568008",
              color: "#fff",
              marginLeft:'5px'
            }}
            onClick={() => {
              setAuth(true);
              setRemark(true);
            }}
          >
            Make Authenticate
          </Button>
        ) : (
          <Button
            type="ghost"
            icon={<WarningOutlined />}
            size="small"
            style={{
              float: "right",
              backgroundColor: "#f04545",
              color: "#fff",
              marginLeft:'5px'
            }}
            onClick={() => {
              setAuth(false);
              setRemark(true);
            }}
          >
            Make Unauthenticate
          </Button>
        )}

        
        <br />
        <br />
        {data ? (
          <>
           <Title>User Information  </Title>
            <br/>
            <Descriptions>
              <Descriptions.Item label="ID">
                <strong>{data?.user_id}</strong>
              </Descriptions.Item>
              <Descriptions.Item label="FIRST NAME">
                <strong>{data?.first_name?.toUpperCase()}</strong>
              </Descriptions.Item>
              <Descriptions.Item label="LAST NAME">
                <strong>{data?.last_name?.toUpperCase()}</strong>
              </Descriptions.Item>
              <Descriptions.Item label="GENDER">
                <strong>{data?.gender?.toUpperCase()}</strong>
              </Descriptions.Item>
              <Descriptions.Item label="MOBILE">
                <strong>{data?.mobile_number}</strong>
              </Descriptions.Item>
              <Descriptions.Item label="DATE OF BIRTH">
                <strong>{data?.date_of_birth}</strong>
              </Descriptions.Item>
              <Descriptions.Item label="COUNTRY">
                <strong>{data?.country?.toUpperCase()}</strong>
              </Descriptions.Item>
              <Descriptions.Item label="COUNTRY CODE">
                <strong>{data?.country_code?.toUpperCase()}</strong>
              </Descriptions.Item>
              
              
            </Descriptions>

           <Title>Address</Title>
            <br/>
            <Descriptions>
              <Descriptions.Item label="CITY">
                <strong>{data?.address?.city?.toUpperCase()}</strong>
              </Descriptions.Item>
              <Descriptions.Item label="STREET ADDRESS">
                <strong>{data?.address?.street_address}</strong>
              </Descriptions.Item>
              <Descriptions.Item label="POST CODE">
                <strong>{data?.address?.post_code}</strong>
              </Descriptions.Item>
            </Descriptions>

       

            <Title>Logs </Title>
            <br />
            {data?.logs ? (
              <Timeline mode="left">
                {data.logs.map((item, index) => (
                  <Timeline.Item
                    label={makeLocalTime(item?.created_at)}
                    keys={index}
                  >
                    {item?.message}
                  </Timeline.Item>
                ))}
              </Timeline>
            ) : (
              <Empty />
            )}
          </>
        ) : null}
        <br />
        <br />
      </Wrapper>
      <Remarks
        title=" "
        btn="Update"
        placement="bottom"
        visible={remark}
        fnc={() => setRemark(false)}
        id={[data?.user_id, auth]}
        delFnc={changeAppUserAuth}
        refresh={handleRefresh}
      />
    </Content>
  );
};

export default connect(null, {
  getAppUsersDetails,
  changeAppUserAuth
})(AppUserDetails);
